module.exports = __webpack_public_path__ + "static/media/4ODA12.cdbb2175.jpg";